export default __webpack_public_path__ + "static/media/newroadmap.26fb6669.png";